import {take, select} from "redux-saga/effects";
import {put} from "../../../../shared/SagaService";
import actions from "../../actions";
import { SubscriptionCheck } from "bukku/components/Access/helper/subscription/SubscriptionCheck";
import { SubscriptionScopeKey } from "bukku/components/Access/helper/subscription/enum/SubscriptionScopeKey";

function* waitForSuccessAction() {
    let loop = true;
    while (loop) {
        yield take(actions.TRANSACTION_READ_PENDING_INVOICE_SUCCESS);
        // if (successAction.transactionType === transactionType)
        loop = false;
    }
}
export function* readPendingInvoices(transaction) {
    if (transaction.date && transaction.currency_code) {
        const companyCurrencyCode = yield select(state => state.Auth.companyCurrencyCode);

        const hasMultiCurrencySub =
            SubscriptionCheck.withKeys(SubscriptionScopeKey.MULTI_CURRENCY).hasSubscriptionTo();

        yield put(actions.transactionReadPendingInvoices({
            date: transaction.date,
            currency_code: hasMultiCurrencySub ? transaction.currency_code : companyCurrencyCode,
        }));

        yield waitForSuccessAction();
    }
}
